// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '영진약품',
  targetSheetName: '수수료율표',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: 'EDI코드',
    drugName: '품목명',
    price: '기준약가',
    commissionRate: '수수료율',
    commissionNote: '비 고',
  },
  requiredHeaders: [
    'EDI코드',
    '품목명',
    '기준약가',
    '2026.01.01 기준약가변경',
    '수수료율',
    '비 고',
    '성분명',
    '분류명',
    '자사/위탁',
    '자체생동',
    '추가 약가인하 대상/비대상',
    '약가등재시점 1단계(2012년 이전)/ 2단계(2013년 이후)',
    '비고',
  ],
});
